import { Injectable } from '@angular/core';
import { StudentInfo } from '../shared/interfaces/student-info';

const PRESCHOOL_AGE_THRESHOLD: number = 5;

@Injectable({
  providedIn: 'root',
})
export class StudentStore {
  initializeSelectedStudent(student: StudentInfo): void {
    this.studentInfo = student;
    localStorage.setItem('nycId', this.studentInfo.nycId);
  }

  initializeSelectedStudentId(studentId: string): void {
    localStorage.setItem('nycId', studentId);
  }

  getnycIdFromLocalStorage(): string {
    const nycId: string | null = localStorage.getItem('nycId');
    return (nycId ? nycId : '');
  }

  isPreSchoolStudent(dob: Date): boolean {
    const dobYear: number = dob.getFullYear();
    const currentYear: number = new Date().getFullYear();

    if (currentYear - dobYear < PRESCHOOL_AGE_THRESHOLD) {
      return true;
    }
    else {
      return false;
    }
  }

  get SelectedStudentInfo(): StudentInfo {
    return this.studentInfo;
  }

  private studentInfo: StudentInfo;
}
